export default {
  fields: {
    demo: {
      label: 'Luo demo',
    },
    ai: {
      label: 'AI-optimoitu',
    },
    restaurant_type: {
      label: 'Valitse ravintolan tyyppi',
      types: {
        Pizza: 'Pizza 🍕',
        PizzaDelivery: 'Pizzan kotiinkuljetus 🍕🚗',
        PizzaNeapolitan: 'Napolilainen pizza 🍕',
        Italian: 'Italialainen 🇮🇹',
        Burger: 'Hampurilainen 🍔',
        Turkish: 'Turkkilainen 🇹🇷',
        Mexican: 'Meksikolainen 🌮',
        Sushi: 'Sushi 🍱',
        Japanese: 'Japanilainen 🇯🇵',
        Vietnamese: 'Vietnamilainen 🇻🇳',
        Thai: 'Thaimaalainen 🇹🇭',
        Asian: 'Aasialainen 🍜',
        Indian: 'Intialainen 🥘',
        Bowls: 'Bowlit 🥣',
        Vegan: 'Vegaaninen 🥑',
        Greek: 'Kreikkalainen 🏛️',
        Cafe: 'Kahvila ☕️',
        Brunch: 'Brunssi 🍵',
        Oriental: 'Itämainen / Lähi-idän 🧆',
        Spanish: 'Espanjalainen / Tapas 🇪🇸',
        Persian: 'Persialainen 🫖',
      },
    },
    plugins: {
      reservations: 'Varaukset',
      reservations_plan_hint:
        'Varaukset vaativat Partner-suunnitelman. Sinua pyydetään aktivoimaan se kohteelle {{name}}, kun luot verkkosivun.',
      catering: 'Pitopalvelu',
      events: 'Tapahtumat',
    },
    quarter: {
      label: 'Kaupunginosa',
      address_placeholder: 'Syötä osoite',
      quarter_placeholder: 'Syötä kaupunginosa',
    },
    delivery_areas: {
      label: 'Millä alueilla toimitte kaupungissa?',
      city_placeholder: 'Syötä kaupunki',
      district_placeholder: 'Alue 1, Alue 2, Alue 3',
    },
    best_dishes: {
      label: 'Mitkä ovat 3 suosituinta ruokaanne?',
      placeholder: 'Syötä ruoat (Kanaburgeri, Juustoburgeri, jne.)',
    },
    dietary_attributes: {
      label: 'Onko teillä vaihtoehtoja seuraaville ruokavalioille:',
      placeholder: 'Valitse ruokavalio-ominaisuudet',
      types: {
        vegetarian: 'Kasvisruoka',
        vegan: 'Vegaaninen',
        halal: 'Halal',
        gluten_free: 'Gluteeniton',
        dairy_free: 'Maidoton',
        spicy: 'Tulinen',
      },
    },
    family_owned: {
      label: 'Perheyritys?',
      yes: 'Kyllä',
      no: 'Ei',
    },
    business_founding_year: {
      label: 'Minä vuonna ravintola perustettiin?',
    },
    business_owners: {
      label: 'Yrityksen omistajat',
      placeholder: 'Syötä yrityksen omistaja',
    },
    notes: {
      label: 'Lisää huomautuksia (valinnainen)',
      placeholder: 'Esimerkki: yhteisöllinen ravintola, aloitteet, pariskunnan omistama...',
    },
    about_us: {
      title: 'Meistä (esikatselu)',
    },
  },
  sections: {
    plugins: 'Laajennukset',
    company_info: 'Luo yritystiedot',
  },
  buttons: {
    find_district: 'Etsi kaupunginosa',
    generate: 'Luo',
    products: 'Tuotteet',
    add: 'Lisää',
  },
};
